var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vliveExampleGuideCover"},[_c('div',{staticClass:"phone-model phone_model phone_model2"},[_c('div',{staticClass:"vlive-guide-cover"},[_c('img',{attrs:{"src":_vm.liveInfoData.posterurl.furl,"alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }